import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

type Props = {
  collapsed: boolean;
  onClick: () => void;
};

const MenuItemNewSpace = ({ collapsed, onClick }: Props) => (
  <div className="flex py-1 pl-1">
    <Button className="p-1 text-neutral-900  hover:text-taskonioGreen-600" size="small" onClick={onClick}>
      <div className="flex items-center justify-center gap-1 ">
        <PlusOutlined className="" />
        {!collapsed && <div className="text-sm font-medium leading-none ml-1">New Space</div>}
      </div>
    </Button>
  </div>
);

export default MenuItemNewSpace;
